<app-navbar-style-two></app-navbar-style-two>
<app-partner></app-partner>

<!-- Page Header -->
<div class="page-title-area mt-0" *ngFor="let content of pageTitle"
  [ngStyle]="{ 'background-image': 'url(' + content.bgImage + ')' }">
  <h1>{{ content.title }}</h1>
  <ul>
    <li><a routerLink="/">Home</a></li>
    <li>{{ content.title }}</li>
  </ul>
</div>

<!-- Gallery Section -->
<section class="seaction section-bg">
  <div class="container mt-5">

    <!-- Section Title -->
    <div class="section-title text-center">
      <h1>Our Showroom Gallery</h1>
      <p>Explore our state-of-the-art fire protection systems and safety solutions — engineered to protect what matters most.</p>
    </div>

    <!-- Image Grid -->
    <div class="row py-4">
      <div class="col-lg-3 col-md-4 col-sm-6 mb-4" *ngFor="let image of displayedImages; trackBy: trackByFn">
        <div class="gallery-item">
          <img
            [src]="image"
            alt="Gallery Image"
            loading="lazy"
            (load)="onImageLoad($event)"
            (click)="openModal(image)"
            class="img-fluid fade-in placeholder"
          />
        </div>
      </div>
    </div>

    <!-- Load More Button -->
    <div class="text-center" *ngIf="displayedImages.length < allImages.length">
      <button class="btn btn-primary load-more-btn" (click)="loadMore()">Load More</button>
    </div>

    <!-- Modal View -->
    <div class="image-modal" *ngIf="isModalOpen" (click)="closeModal()">
      <span class="close-btn" (click)="closeModal(); $event.stopPropagation()">&times;</span>

      <!-- Left Arrow -->
      <span class="carousel-arrow left" (click)="showPreviousImage(); $event.stopPropagation()" aria-label="Previous image">
        &#10094;
      </span>

      <!-- Image -->
      <img
        class="modal-content"
        [src]="currentImage"
        alt="Full Image"
        (click)="$event.stopPropagation()"
      />

      <!-- Right Arrow -->
      <span class="carousel-arrow right" (click)="showNextImage(); $event.stopPropagation()" aria-label="Next image">
        &#10095;
      </span>
    </div>
  </div>
</section>
